import { ReactElement, useEffect, useState } from 'react';
import { useCopyToClipboard } from 'react-use';
import { CheckIcon, DocumentDuplicateIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '../tooltip';

import { useTranslation } from 'react-i18next';

export function CopyToClipboard({
  value,
  className = '',
  onCopy,
}: {
  value: string;
  className?: string;
  onCopy?: () => void;
}): ReactElement<any> {
  const { t } = useTranslation('designSystem');
  const [state, copy] = useCopyToClipboard();
  const [showCopied, setShowCopied] = useState(false);

  useEffect(() => {
    if (!state.error && state.value) {
      setShowCopied(true);
      onCopy?.();
      setTimeout(() => {
        setShowCopied(false);
      }, 1500);
    }
  }, [state, onCopy]);

  return showCopied ? (
    <Tooltip label={t('copied')}>
      <CheckIcon className="flex h-5 w-5 flex-shrink-0 text-gray-500 dark:text-gray-400" />
    </Tooltip>
  ) : (
    <button onClick={() => copy(value || '')}>
      <DocumentDuplicateIcon
        className={`flex h-5 w-5 flex-shrink-0 cursor-pointer text-gray-500 dark:text-gray-400 ${className}`}
      />
    </button>
  );
}
